import React from 'react';
import type { IconProps } from '../types';

export const IconPositions: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    {/* Portfolio/positions icon - stacked layers representing holdings */}
    <rect x="3" y="5" width="14" height="3" rx="0.5" stroke={color} strokeWidth="1.5"/>
    <rect x="3" y="10" width="14" height="3" rx="0.5" stroke={color} strokeWidth="1.5"/>
    <rect x="3" y="15" width="14" height="2" rx="0.5" fill={color} fillOpacity="0.2" stroke={color} strokeWidth="1.5"/>
    {/* Arrow indicator for P&L */}
    <path d="M14 8L16 6L14 4" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
